// extracted by mini-css-extract-plugin
module.exports = {"library":"Library_library__Su5lv","open":"Library_open__3vUmE"};